<template>
    <v-card>
        <v-navigation-drawer v-model="show" :mini-variant.sync="mini" fixed style="background-color: #F2F2F2;">

            <v-list-item class="px-2">
                <v-list-item-avatar v-if="mini">
                    <v-app-bar-nav-icon @click.stop="switchClipped()"></v-app-bar-nav-icon>
                </v-list-item-avatar>
                <v-spacer></v-spacer>
                <v-app-bar-nav-icon @click.stop="switchClipped()">
                </v-app-bar-nav-icon>
            </v-list-item>

             <img v-if="mini" src="/logo_background.jpg" alt="" title=""
                style="width:50px; margin-left: 5px; margin-bottom: 5px; border-radius: 50%;" />

            <v-list dense>
                <template v-if="!mini">
                    <v-list-item>
                        <v-list-item-avatar :size="150" style="margin: auto;">
                            <v-img src="/logo_background.jpg"></v-img>
                        </v-list-item-avatar>
                    </v-list-item>

                    <v-list-item class="mt-5">
                        <v-list-item-content style="text-align: center;">
                            <v-list-item-title class="text-h6">
                                {{ trans('layout.title') }}
                            </v-list-item-title>
                            <v-list-item-subtitle></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>

                <v-divider class="my-5"></v-divider>
                <template v-for="(item, i) in menu">
                    <v-list-item v-if="!item.items" :value="isActive(item)" @click="navigate(item)" :key="i" :href="item.url"
                        v-bind="item.bind || {}" :style="itemStyle(item)">
                        <v-list-item-action>
                            <v-icon v-if="item.icon" v-text="item.icon" :color="item.color" :style="itemStyle(item)"></v-icon>
                        </v-list-item-action>
                        <v-list-item-content :class="item.color && item.color + '--text'">
                            <v-list-item-title v-text="item.name"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-group v-else :key="i" :prepend-icon="item.icon" no-action v-bind="item.bind || {}">
                        <v-list-item slot="activator">
                            <v-list-item-content>
                                <v-list-item-title v-text="item.name"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-for="(subItem, k) in item.items" v-bind:key="i + '-' + k" @click="navigate(subItem)">
                            <v-list-item-content>
                                <v-list-item-title v-text="subItem.name"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-icon v-if="subItem.icon" v-text="subItem.icon"></v-icon>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list-group>
                </template>
            </v-list>
        </v-navigation-drawer>
    </v-card>
</template>
<script>
import { mapGetters } from 'vuex'; //Vuex getter map

export default {
    props: {
        clipped: { type: Boolean, default: true },
        value: { required: true },
    },


    data() {
        let mini = this.clipped;
        let close = (mini) ? true : false;

        let current = localStorage.getItem('current_menu_voice');

        return {
            mini,
            close,
            current
        };
    },
    computed: {
        show: {
            get() { return this.value; },
            set(v) { this.$emit('input', v); }
        },
        ...mapGetters({
            menu: 'mainMenu',
        })
    },

    methods: {
        isCurrent(item) {
            return item.name == this.current;
        },

        itemStyle(item) {
            if (this.isActive(item)) {
                return 'background-color: var(--v-primary-base); border-radius: 0px 20px 20px 0px; color: #FFFFFF;';
            }
            return '';
        },

        navigate(item) {
            localStorage.setItem('navbar_clipped', this.close);
            //if (item.url) location.href = item.url;
            localStorage.setItem('current_menu_voice', item.name);
            this.current = item.name;
        },

        switchClipped() {
            this.mini = !this.mini;
            this.close = !this.close;
            this.$emit('mini-version', this.mini);
            return this.mini;
        },
        isActive(item) {
            let url = location.pathname.split("/")[1];
            let active = item.url.split("/")[3];

            return url === active || (url === 'statics' && active === 'team') || (url === 'home' && active === 'targets');
        }
    },
    filters: {
    }
}
</script>
